import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import BudgetDataGrid from 'src/components/BudgetDataGrid/BudgetDataGrid'
import { BudgetsFiltersBody } from 'src/components/BudgetsBoxWithFilters/BudgetsBoxWithFilters'
import BudgetsTableLarge from 'src/components/BudgetsTableLarge/BudgetsTableLarge'
import BudgetsTableSmall from 'src/components/BudgetsTableSmall/BudgetsTableSmall'
import { CreditCardListModel } from 'src/models/creditCard.models'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { InfiniteScrollProps } from 'src/types'
import { css } from 'styled-components'

interface BudgetsTableProps {
  className?: string
  budgets: CreditCardListModel[]
  isSlim: boolean
  clientHeight?: number
  filtersBody?: BudgetsFiltersBody
  infiniteScrollProps?: InfiniteScrollProps<BudgetsFiltersBody>
}

const BudgetsTable: React.FC<BudgetsTableProps> = (props) => {
  const showNewBudgetsTable = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_new_budgets_table

  return (
    <div>
      {showNewBudgetsTable ? (
        <BudgetDataGrid
          budgets={props.budgets}
          infiniteScrollProps={props.infiniteScrollProps}
          filters={props.filtersBody}
          clientHeight={props.clientHeight}
        />
      ) : (
        <>
          <div
            css={css`
              display: none;

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: block;
              `)};

              ${props.isSlim &&
              css`
                display: block;
              `};
            `}
          >
            <BudgetsTableSmall budgets={props.budgets} isSlim={props.isSlim} />
          </div>
          <div
            css={css`
              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: none;
              `)};

              ${props.isSlim &&
              css`
                display: none;
              `};
            `}
          >
            <BudgetsTableLarge budgets={props.budgets} />
          </div>
        </>
      )}
    </div>
  )
}

export default BudgetsTable
